import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", (value) => {
   return moment(value).format("DD MMMM YYYY");
});
